/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_Hubspot_Deal_StageInputs */

const en_reference_dataset_hubspot_deal_stage = /** @type {(inputs: Reference_Dataset_Hubspot_Deal_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HubSpot deal stages`)
};

/**
* | output |
* | --- |
* | "HubSpot deal stages" |
*
* @param {Reference_Dataset_Hubspot_Deal_StageInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_hubspot_deal_stage = /** @type {((inputs?: Reference_Dataset_Hubspot_Deal_StageInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_Hubspot_Deal_StageInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_hubspot_deal_stage(inputs)
});